document.addEventListener("DOMContentLoaded", initMixPicker);

document.addEventListener("shopify:section:load", initMixPicker);

function initMixPicker() {

  const sections = document.querySelectorAll(".mix-picker");

  console.log("Mix picker sections:", sections.length);


  sections.forEach(function(section) {

    const inputs = section.querySelectorAll(".mix-picker__qty");

    console.log("Inputs found in section:", inputs.length);


    if (!inputs.length) return;


    const totalDisplay = section.querySelector("[id^='MixTotal']");
    const priceDisplay = section.querySelector("[id^='MixPrice']");


    function updatePrice() {

      let total = 0;

      inputs.forEach(function(input) {
        total += Number(input.value) || 0;
      });


      if (totalDisplay) {
        totalDisplay.textContent = total;
      }


      let price = 0;

      if (total > 0) {
        price = 15 + ((total - 1) * 10);
      }


      if (priceDisplay) {
        priceDisplay.textContent =
          "$" + price.toFixed(2);
      }


      console.log(
        "Bundle:",
        total,
        price
      );

    }


    inputs.forEach(function(input) {

      input.addEventListener(
        "input",
        updatePrice
      );

      input.addEventListener(
        "change",
        updatePrice
      );

    });

  });

}